import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import APIKit from '../../config/APIKit';

export const fetchProfile = createAsyncThunk(
  'profile/fetchProfile',
  async (_, { rejectWithValue }) => {
    try {
      const response = await APIKit.get(`store/details`);
      if(response.status){
         const pathParts = window.location.pathname.split("/").filter(Boolean);
         localStorage.setItem("store-key" ,pathParts?.[0])
        return {
          ...response.data,
          key : pathParts?.[0]
        };
      }else{
        localStorage.clear();
        return rejectWithValue('Profile get failed');
      }
    } catch (error) {
      if (error && typeof error === 'object' && error.response) {
        return rejectWithValue(error.response?.data || 'Profile get failed');
      }
      return rejectWithValue('Profile get failed');
    }
  }
);
const localkey = localStorage.getItem("store-key")
const profileSlice = createSlice({
  name: 'profile',
  initialState: {
    profile: null,
    status: 'idle',
    error: null,
    storeKey : localkey||""
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProfile.pending, (state) => {
        state.status = 'loading';
        state.error = null;
        state.storeKey =""
      })
      .addCase(fetchProfile.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.profile = action.payload.data || action.payload;
        state.error = null;
        state.storeKey =action.payload.key
      })
      .addCase(fetchProfile.rejected, (state, action) => {
        state.status = 'failed';
        state.error = typeof action.payload === 'string' ? action.payload : 'Banner get failed';
        state.storeKey =""
      });
  },
});

export default profileSlice.reducer;
